/**
 * String utility functions for text formatting and manipulation.
 */

/**
 * Returns the singular or plural form of a word based on the count.
 *
 * @param count - The number used to determine singular vs plural
 * @param singular - The singular form of the word
 * @param plural - The plural form of the word
 * @returns The appropriate form based on the count
 *
 * @example
 * pluralize(1, "usuario", "usuarios") // returns "usuario"
 * pluralize(5, "usuario", "usuarios") // returns "usuarios"
 * pluralize(0, "elemento", "elementos") // returns "elementos"
 */
export const pluralize = (
  count: number,
  singular: string,
  plural: string
): string => {
  return count === 1 ? singular : plural;
};
